// Version : 0.0.1
// Author : VISHAL BHARATHI
// LastEdit : VISHAL BHARATHI
// Last ADD : ROUTER NAME CASE CHANGES & COMMENT LINES ADDED
// MODFIED DATA : 07-08-2025

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************** GET QUESTIONNAIRE DETAILS START *********************** */
export const questionnaireListGet = (listData: any) => {
	const data = {
		GetAllQuestionnaireListToken: listData,
	};
	const url = `${API_URL}getQuestionnaireList`;
	return makeApiCall(url, data);
};
/** ***************** GET QUESTIONNAIRE DETAILS END *********************** */

/** ***************** DELETE QUESTIONNAIRE DETAILS START *********************** */
export const questionnaireDelete = (deleteData: any) => {
	const data = {
		DeleteQuestionnaireToken: deleteData,
	};
	const url = `${API_URL}deleteQuestionnaire`;
	return makeApiCall(url, data);
};
/** ***************** DELETE QUESTIONNAIRE DETAILS END *********************** */

/** ***************** DELETE QUESTION DETAILS START *********************** */
export const questionDelete = (deleteData: any) => {
	const data = {
		DeleteQuestionToken: deleteData,
	};
	const url = `${API_URL}deleteQuestion`;
	return makeApiCall(url, data);
};
/** ***************** DELETE QUESTION DETAILS END *********************** */

/** ***************** UPDATE QUESTIONNAIRE DETAILS START *********************** */
export const questionnaireUpdate = (updateData: any) => {
	const data = {
		QuestionnaireUpdateToken: updateData,
	};
	const url = `${API_URL}updateQuestionnaire`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE QUESTIONNAIRE DETAILS END *********************** */

/** ***************** FETCH QUESTIONNAIRE DETAILS START *********************** */
export const questionnaireDetailsFetch = (listData: any) => {
	const data = {
		QuestionnaireFetchToken: listData,
	};
	const url = `${API_URL}fetchQuestionnaire`;
	return makeApiCall(url, data);
};
/** ***************** FETCH QUESTIONNAIRE DETAILS END *********************** */

/** ***************** ADD QUESTIONNAIRE DETAILS START *********************** */
export const questionnaireDetailsAdd = (addData: any) => {
	const data = {
		QuestionnaireCreateAddToken: addData,
	};
	const url = `${API_URL}createAddQuestionnaire`;
	return makeApiCall(url, data);
};
/** ***************** ADD QUESTIONNAIRE DETAILS END *********************** */

/** ***************** FETCH MODULE LIST START *********************** */
export const moduleListFetch = (listData: any) => {
	const data = {
		ModuleListFetchToken: listData,
	};
	const url = `${API_URL}fetchModuleList`;
	return makeApiCall(url, data);
};
/** ***************** FETCH MODULE LIST END *********************** */
